// extracted by mini-css-extract-plugin
module.exports = {"indicatorItem":"tMTQTula","focused":"Hoq94QPL","indicatorText":"zFKzTKUv","secondary":"rIjgDjV5","indicatorSmallText":"p5v5hqmb"};